import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import PageHeading from '../../components/PageHeading/PageHeading';
import { useNavigate, useParams } from 'react-router-dom';
import { colors } from '../../config/constants';
import Button from '../../components/Button/Button';
import instance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import Dailog from '../../components/Dailog/Dailog';
import { keyword, successMessage } from '../../config/keyword';
import WebsiteDMCA from './WebsiteDMCA/WebsiteDMCA';
import Tabs from '../../components/Tabs/Tabs';
import { Role, SiteMapping, SiteStatus } from '../../config/enum';
import WebsiteArchives from './WebsiteArchives';
import { StateProps } from '../../redux/reducer';
import { errorMessage } from '../../config/errorsMsg';
import Input from '../../components/Input/Input';
import { errorMessageAutoCapitalize } from '../../config/helpers';

type SiteProps = {
  host: string;
  name: string;
  organizationId: string;
  siteId: string;
  siteOrganizationId: string;
  siteSequenceNumber: number;
  siteStatus: number;
  siteUrl: string;
  canRecrawl: boolean;
};

export type IndexProps = {
  id: string;
  siteIndexId: string;
  siteOrganizationId: string;
  totalIgnoredMarked: number;
  totalRevisitedMarked: number;
  totalDmcaMarked: number;
  totalHitCount: number;
  isActive: boolean | null;
  indexNumber: number;
  siteIndexStatus: number;
  name: string;
  totalPages: number;
  canDelete: boolean | null;
  canActivate: boolean | null;
  isProcessed: boolean | null;
  siteStatus: number | undefined;
  message: string | null;
};

type RecrawlProps = {
  newSiteIndexExists: boolean | null;
  created: string | null;
  totalPages: number;
};

const WebsiteDetailsAdmin = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState<string>(keyword.INDEXES);
  const [isDeletePopup, setIsDeletePopup] = useState<boolean>(false);
  const [confirmDailog, setConfirmDialog] = useState<string>('');
  const [siteEdit, setSiteEdit] = useState<boolean>(false);
  const [state, setState] = useState<any>([]);
  const [site, setSite] = useState<SiteProps>({
    host: '',
    name: '',
    organizationId: '',
    siteId: '',
    siteOrganizationId: '',
    siteSequenceNumber: 0,
    siteStatus: 0,
    siteUrl: '',
    canRecrawl: false,
  });
  const initialIndexState = [
    {
      id: '',
      siteIndexId: '',
      siteOrganizationId: '',
      totalIgnoredMarked: 0,
      totalRevisitedMarked: 0,
      totalDmcaMarked: 0,
      totalHitCount: 0,
      isActive: null,
      indexNumber: 0,
      siteIndexStatus: 0,
      name: '',
      totalPages: 3239,
      canDelete: null,
      canActivate: null,
      isProcessed: null,
      siteStatus: 0,
      message: '',
    },
  ];
  const [siteIndex, setSiteIndex] = useState<IndexProps[]>(initialIndexState);
  const [indicies, setIndicies] = useState<string>('');
  const [dialogLabel, setDialogLabel] = useState<string>('');
  const [formError, setFormError] = useState<any>({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [canRecrawlResponce, setCanRecrawlResponce] = useState<RecrawlProps>({
    newSiteIndexExists: null,
    created: null,
    totalPages: 0,
  });
  const { name } = site;
  const tabObj = [
    {
      label: keyword.INDEXES,
      onPress: () => {
        setActiveTab(keyword.INDEXES);
      },
    },
    // {
    //   label: keyword.REVIEW,
    //   onPress: () => {
    //     setActiveTab(keyword.REVIEW);
    //   },
    // },
    {
      label: keyword.DMCA,
      onPress: () => {
        setActiveTab(keyword.DMCA);
      },
    },
    {
      label: keyword.ARCHIVES,
      onPress: () => {
        setActiveTab(keyword.ARCHIVES);
      },
    },
  ];

  useEffect(() => {
    const breadcrumb = [
      { path: '/websiteAdmin', name: 'Website' },
      { path: `/websiteDetail/${id}`, name: 'Website Details' },
    ];
    dispatch(update_breadcrumb(breadcrumb));
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (activeTab === keyword.INDEXES) {
      getWebsiteByIndex();
      getWebsiteById();
    }
  }, [activeTab]);
  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      updateSiteOrganization();
    }
  }, [formError]);
  const validation = () => {
    const error: any = {};
    if (!name) {
      error.name = errorMessage.emptyName;
    } else if (name.length > 32) {
      error.name = errorMessage.siteValidLengthName;
    }
    return error;
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSite({ ...site, [event.target.name]: event.target.value });
    setSite({
      ...site,
      [event.target.name]: event.target.value,
    });
    if (event.target.value !== '') {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `${errorMessageAutoCapitalize(
          event.target.name
        )} is required`,
      });
    }
  };
  const getWebsiteById = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .get(`/site-organizations/${id}`)
      .then((response) => {
        if (response.status === 200) {
          setSite(response.data);
          setState(response.data);
          if (response.data.canRecrawl === true) {
            if (userInfo.role !== Role.Admin) {
              dispatch(updateIsLoading(false));
            } else {
              canRecrawlling();
            }
          } else {
            setCanRecrawlResponce({
              newSiteIndexExists: null,
              created: null,
              totalPages: 0,
            });
            dispatch(updateIsLoading(false));
          }
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const getWebsiteByIndex = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .get(`/site-organizations/${id}/indexes`)
      .then((response) => {
        if (response.status === 200) {
          setSiteIndex(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const deleteIndex = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .delete(`/site-organization-indexes/${indicies}`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.SITE_INDEX_DELETE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          setIsDeletePopup(false);
          getWebsiteById();
          getWebsiteByIndex();
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const onSubmit = () => {
    if (confirmDailog === 'delete' && dialogLabel === 'Site Index') {
      deleteIndex();
    } else if (confirmDailog === 'recrawl') {
      reCrawlSite();
    } else {
      deleteSite();
    }
  };

  const siteOrganizationIndexIdProps = () => {
    return siteIndex?.filter((item: IndexProps) => item.isActive === true)[0];
  };

  const updateWebsiteIndex = async (id: string) => {
    await instance
      .put(`/site-organization-indexes/${id}/activate`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.SITE_INDEX_ACTIVATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          getWebsiteById();
          getWebsiteByIndex();
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const reCrawlSite = async () => {
    await instance
      .post(`/site-organizations/${id}/re-crawl`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.SITE_RECRAWL_REQUEST,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          setIsDeletePopup(false);
          getWebsiteByIndex();
          getWebsiteById();
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const deleteSite = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .delete(`/site-organizations/${id}`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.SITE_DELETE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          setIsDeletePopup(false);
          setTimeout(() => {
            navigate(`/websiteAdmin`);
          }, 1000);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };
  const canRecrawlling = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .get(`/site-organizations/${id}/indexes/new`)
      .then((response) => {
        if (response.status === 200) {
          setCanRecrawlResponce(response.data);
          dispatch(updateIsLoading(false));
        } else {
          setCanRecrawlResponce({
            newSiteIndexExists: null,
            created: null,
            totalPages: 0,
          });
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };
  const newSiteIndexExisting = async (arg: boolean) => {
    dispatch(updateIsLoading(true));
    await instance
      .put(`/site-organizations/${id}/indexes/new/${arg}`)
      .then((response) => {
        if (response.status === 200) {
          getWebsiteById();
          getWebsiteByIndex();
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };
  const updateSiteOrganization = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .put(`/site-organizations/${id}`, site)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.SITE_ORGANIZATION_UPDATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
        }
        getWebsiteById();
        setSiteEdit(false);
        dispatch(updateIsLoading(false));
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message || err.response.data.errors.Code[0],
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };
  const siteHandleEdit = () => {
    setSiteEdit(!siteEdit);
  };
  const websiteEditCancel = () => {
    setSiteEdit(false);
    setSite(state);
    setFormError({});
    setIsSubmit(false);
  };
  const siteHandleEditUpdate = () => {
    setFormError(validation());
    setIsSubmit(true);
  };
  return (
    <>
      <div className="px-2">
        <PageHeading label="Website Details" />
        <div>
          <div
            className={`bg-white rounded-sm justify-between ${colors.primaryText} p-2`}
          >
            <Tabs
              obj={tabObj}
              activeTab={activeTab}
              activeKey={siteOrganizationIndexIdProps()?.id}
            />
            {activeTab === keyword.INDEXES && (
              <>
                <div className="mt-5">
                  <div className="bg-white p-4 rounded shadow-md border border-[#f2f3f5]">
                    <div className="sm:flex text-md mb-2">
                      <div className="sm:w-1/3 ">Site Url</div>
                      <div className=" text-black flex sm:w-2/4">
                        <div>{site.siteUrl}</div>
                      </div>
                    </div>
                    <div className="sm:flex text-md mb-2">
                      <div className="sm:w-1/3 ">Name</div>
                      {siteEdit ? (
                        <div className="sm:w-2/4">
                          <Input
                            type={'text'}
                            placeholder={'Enter Site Name'}
                            value={site.name}
                            name={'name'}
                            onChange={handleChange}
                            error={formError?.name}
                          />
                        </div>
                      ) : (
                        <div className=" text-black flex sm:w-2/4">
                          <div>{site.name}</div>
                        </div>
                      )}
                    </div>
                    <div className="sm:flex text-md mb-2">
                      <div className="sm:w-1/3 ">Host</div>
                      <div className=" text-black flex sm:w-2/4">
                        <div>{site.host}</div>
                      </div>
                    </div>
                    <div className="sm:flex text-md mb-2">
                      <div className="sm:w-1/3 ">Site Number</div>
                      <div className=" text-black flex sm:w-2/4">
                        <div>{site.siteSequenceNumber}</div>
                      </div>
                    </div>
                    <div className="sm:flex text-md mb-2">
                      <div className="sm:w-1/3 ">Status</div>
                      <div className=" text-black flex sm:w-2/4">
                        <div>{SiteMapping[site.siteStatus as SiteStatus]}</div>
                      </div>
                    </div>
                    {userInfo.role === Role.Admin &&( <div className="flex items-center justify-end">
                      <div className="flex justify-center md:justify-end pt-5 pr-2 md:pt-0">
                       {siteEdit ? (
                          <div className="flex mx-auto md:mx-0 justify-end w-[250px]">
                            <div className="mr-4">
                              <Button
                                label="Update"
                                buttonType="primary"
                                type="button"
                                onClick={() => siteHandleEditUpdate()}
                                disabled={state.name === name}
                              />
                            </div>
                            <Button
                              label="Cancel"
                              buttonType="danger"
                              type="button"
                              onClick={() => websiteEditCancel()}
                            />
                          </div>
                        ) : (
                          <div className="flex justify-center md:justify-end">
                            <Button
                              label="Edit"
                              buttonType="primary"
                              type="button"
                              onClick={() => siteHandleEdit()}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    )} 
                  </div>
                </div>
                <div className="p-2 font-bold text-[#176b87] mt-2 text-lg">
                  {activeTab}
                </div>

                <div>
                  {siteIndex.length > 0 ? (
                    <div>
                      {siteIndex
                        .sort(
                          (a: IndexProps, b: IndexProps) =>
                            b.indexNumber - a.indexNumber
                        )
                        ?.map((item: IndexProps, index: number) => (
                          <div
                            className={`shadow-md p-4 border mb-3 rounded border-[#f2f3f5] ${
                              item.isActive ? 'bg-green-100' : 'bg-white'
                            }`}
                            key={index}
                          >
                            <div className="pb-2 font-bold text-[#0369a1] text-base">
                              {item.name}
                            </div>
                            {item.isProcessed ? (
                              <div>
                                <div className="sm:flex text-md mb-2">
                                  <div className="sm:w-1/3 ">
                                    Total Ignored Marked
                                  </div>
                                  <div className=" text-black flex sm:w-2/4">
                                    <div>{item.totalIgnoredMarked}</div>
                                  </div>
                                </div>
                                <div className="sm:flex text-md mb-2">
                                  <div className="sm:w-1/3 ">
                                    Total Revisited Marked
                                  </div>
                                  <div className=" text-black flex sm:w-2/4">
                                    <div>{item.totalRevisitedMarked}</div>
                                  </div>
                                </div>
                                <div className="sm:flex text-md mb-2">
                                  <div className="sm:w-1/3 ">Total DMCA Marked</div>
                                  <div className=" text-black flex sm:w-2/4">
                                    <div>{item.totalDmcaMarked}</div>
                                  </div>
                                </div>
                                <div className="sm:flex text-md mb-2">
                                  <div className="sm:w-1/3 ">Total HitCount </div>
                                  <div className=" text-black flex sm:w-2/4">
                                    <div>{item.totalHitCount}</div>
                                  </div>
                                </div>
                                <div className="sm:flex text-md mb-2">
                                  <div className="sm:w-1/3 ">Total Pages </div>
                                  <div className=" text-black flex sm:w-2/4">
                                    <div>{item.totalPages}</div>
                                  </div>
                                </div>

                                <div className="sm:flex text-md mb-2">
                                  <div className="sm:w-1/3 ">isActive</div>
                                  <div className=" text-black flex sm:w-2/4">
                                    <div>
                                      {item.isActive === false ? 'No' : 'Yes'}
                                    </div>
                                  </div>
                                </div>
                                {item.isActive === true && (
                                  <div className="flex items-center justify-end">
                                    <Button
                                      label="Start Review"
                                      buttonType="primary"
                                      type="button"
                                      onClick={() =>
                                        navigate(
                                          `/websiteReview/${
                                            siteOrganizationIndexIdProps()?.id
                                          }/${site?.siteOrganizationId}`
                                        )
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div>
                                <div className="sm:flex text-md mb-2">
                                  <div className="sm:w-1/3 ">Status</div>
                                  <div className=" text-black flex sm:w-2/4">
                                    <div>
                                      {item.siteStatus === undefined ||
                                      item.siteStatus === 0
                                        ? 'Pending'
                                        : SiteMapping[item.siteStatus as SiteStatus]}
                                    </div>
                                  </div>
                                </div>
                                {item.message && (
                                  <div className="sm:flex text-md mb-2">
                                    <div className="sm:w-1/3 ">Message</div>
                                    <div className=" text-black flex sm:w-2/4">
                                      <div>{item.message}</div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}

                            <div className="flex justify-center space-x-2 md:justify-end pt-5 md:pt-0">
                              {userInfo.role === Role.Admin && item.canActivate && (
                                <Button
                                  label="Activate"
                                  buttonType="primary"
                                  type="button"
                                  onClick={() => {
                                    updateWebsiteIndex(item.id);
                                  }}
                                />
                              )}
                              {userInfo.role === Role.Admin && item.canDelete && (
                                <Button
                                  label="Delete"
                                  buttonType="danger"
                                  type="button"
                                  onClick={() => {
                                    setIsDeletePopup(true);
                                    setConfirmDialog('delete');
                                    setIndicies(item.id);
                                    setDialogLabel('Site Index');
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        ))}
                    </div>
                  ) : (
                    <div className="px-2"> No Index found!</div>
                  )}
                </div>
                {userInfo.role === Role.Admin &&
                  canRecrawlResponce.newSiteIndexExists && (
                    <div className="p-2 shadow-lg border rounded-sm mb-4">
                      <p className="text-blue-500 mb-1">
                        {' '}
                        A new index is available.
                      </p>
                      <table>
                        <tr>
                          <td className="font-semibold">Created &nbsp;</td>{' '}
                          <td>:&nbsp;{canRecrawlResponce.created} ago</td>
                        </tr>
                        <tr className="mt-2">
                          <td className="font-semibold">Total pages &nbsp;</td>{' '}
                          <td>:&nbsp; {canRecrawlResponce.totalPages}</td>
                        </tr>
                      </table>
                      <div className="flex items-center justify-end">
                        <div> Do you want to use this index? </div>
                        <div className="px-2">
                          <Button
                            label="Yes"
                            buttonType="success"
                            type="button"
                            onClick={() => newSiteIndexExisting(true)}
                          />
                        </div>
                        <div>
                          <Button
                            label="No"
                            buttonType="danger"
                            type="button"
                            onClick={() => newSiteIndexExisting(false)}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                <div className="flex justify-center items-center space-x-3">
                  {userInfo.role === Role.Admin && site.canRecrawl && (
                    <div className="flex items-center justify-center mt-2">
                      <Button
                        label="Re-crawl"
                        buttonType="primary"
                        type="button"
                        onClick={() => {
                          setIsDeletePopup(true);
                          setConfirmDialog('recrawl');
                          setDialogLabel('Site');
                        }}
                      />
                    </div>
                  )}

                  {userInfo.role === Role.Admin && site.canRecrawl && (
                    <div className="flex items-center justify-center mt-2">
                      <Button
                        label="Delete Site"
                        buttonType="danger"
                        type="button"
                        onClick={() => {
                          setIsDeletePopup(true);
                          setConfirmDialog('delete');
                          setDialogLabel('Site');
                        }}
                      />
                    </div>
                  )}
                </div>
              </>
            )}

            {activeTab === keyword.DMCA && (
              <WebsiteDMCA
                allsiteOrganizationIndexId={siteIndex}
                siteOrganizationIndexId={siteOrganizationIndexIdProps()?.id}
                siteOrganizationId={id}
                siteOrganizationIndexName={siteOrganizationIndexIdProps()?.name}
              />
            )}

            {activeTab === keyword.ARCHIVES && (
              <WebsiteArchives
                allsiteOrganizationIndexId={siteIndex}
                siteOrganizationId={id}
                siteOrganizationIndexId={siteOrganizationIndexIdProps()?.id}
                siteOrganizationIndexName={siteOrganizationIndexIdProps()?.name}
              />
            )}
          </div>
        </div>
      </div>

      <div className="flex justify-center pt-8">
        <Dailog
          isDeletePopup={isDeletePopup}
          setIsPopupOpen={setIsDeletePopup}
          title={dialogLabel}
          onConfirm={onSubmit}
          type={confirmDailog}
        />
      </div>
    </>
  );
};
export default WebsiteDetailsAdmin;
